// The one request that fits a scanned part to a drone, and the words for its refusals.
// AssemblyWorkflow's bench and the drone page's repair session both commit through here,
// so a fit cannot mean two things.

import type { SlotKey } from './ComponentCard';

export type DisplacedTo = 'scrap' | 'qc_hold' | 'stock';

export const DISPLACED_CHOICES: { value: DisplacedTo; label: string; tip: string }[] = [
  { value: 'scrap', label: 'Scrap', tip: 'The old part is dead. It goes to scrap.' },
  { value: 'qc_hold', label: 'QC hold', tip: 'Someone should look at the old part before it is used again.' },
  { value: 'stock', label: 'Stock', tip: 'The old part is fine. It goes back to stock.' },
];

export interface Conflict {
  type: string;
  slot: SlotKey;
  component: string;
  current_drone?: string;
  current_value?: string;
}

/** One sentence per conflict, written from the fields so a single conflict is not said twice. */
export const conflictSentence = (c: Conflict, slotName: string): string =>
  c.type === 'slot_occupied'
    ? `This drone already has ${c.current_value} as its ${slotName}. Replace it with ${c.component}?`
    : `${c.component} is on ${c.current_drone}. Moving it takes it off that drone.`;

/** A 409 that carries conflicts to confirm, from either shape the server answers with. */
export const conflictsOf = (err: any): Conflict[] =>
  err?.status === 409 ? (err?.data?.conflicts || (err?.data?.conflict ? [err.data.conflict] : [])) : [];

/** The commit. `api` is useApi(); `body` is built by the caller. */
export const postAssemblyCommit = (api: any, body: Record<string, unknown>, signal?: AbortSignal) =>
  api.post('/scanner/assembly/commit', { body, silent: true, signal });
